(() => {
  'use strict';
  const PRICE_UPGRADES = new Map([[13900, 0], [14900, 1000], [16900, 2000]]);
  const money = cents => '$' + (cents / 100).toFixed(2);

  function start(root) {
    if (root.dataset.sseReady) return;
    root.dataset.sseReady = 'true';
    const records = [...root.querySelectorAll('[data-sse-product]')].map(node => {
      try {
        return {
          product: JSON.parse(node.textContent), kind: node.dataset.kind,
          color: node.dataset.color || '', group: node.dataset.group || 'essential',
          image: node.dataset.swatchImage || '', hex: node.dataset.swatchColor || '#ccc',
          isNew: node.dataset.new === 'true'
        };
      } catch (error) { console.warn('SSE product parse failed', error); return null; }
    }).filter(Boolean);
    const byKind = key => records.filter(r => r.kind === key);
    console.info('[Saddle Seat Essentials] Loaded products:', records.map(r => ({kind:r.kind,title:r.product.title,variants:r.product.variants?.length,availableVariants:(r.product.variants || []).filter(v => v.available).length}))); 
    const state = {};
    const addButton = root.querySelector('[data-add-bundle]');
    const message = root.querySelector('[data-message]');
    const testCartEnabled = root.dataset.cartEnabled === 'true';
    const setMessage = value => { message.textContent = value; };

    const make = (tag, className, value) => {
      const el = document.createElement(tag);
      if (className) el.className = className;
      if (value != null) el.textContent = value;
      return el;
    };
    const getVariants = r => r?.product?.variants || [];
    const isAvailable = r => getVariants(r).some(v => v.available);
    const optionNames = r => (r.product.options || []).map(o => typeof o === 'string' ? o : o.name);
    const initialValues = r => {
      const v = getVariants(r).find(v => v.available) || getVariants(r)[0];
      return v ? [...(v.options || [])] : [];
    };
    const chosenVariant = key => {
      const s = state[key];
      if (!s) return null;
      return getVariants(s.record).find(v => (v.options || []).every((o, i) => o === s.values[i])) || null;
    };
    const pickedVariant = key => {
      const s = state[key];
      if (!s) return null;
      return getVariants(s.record).find(v => v.available && (v.options || []).every((o, i) => o === s.values[i])) || null;
    };

    function showOptions(key) {
      const slot = root.querySelector(`[data-slot="${key}"]`);
      const target = slot.querySelector('[data-options]');
      target.replaceChildren();
      if (!state[key]) return;
      const { record, values } = state[key];
      optionNames(record).forEach((name, index) => {
        if (key === 'jods' && /^(colou?r|couleur)$/i.test(name)) return;
        const uniqueValues = [...new Set(getVariants(record).map(v => v.options?.[index]).filter(Boolean))];
        if (uniqueValues.length < 2 && name === 'Title') return;
        const group = make('fieldset', 'sse__fieldset');
        const legend = make('legend', 'sse__option-label', name);
        group.append(legend);
        const buttons = make('div', 'sse__option-buttons');
        uniqueValues.forEach(val => {
          const btn = make('button', 'sse__option-button', val);
          btn.type = 'button';
          const matching = getVariants(record).filter(v => (v.options || []).every((o, i) => i === index ? o === val : o === values[i]));
          // Keep sold-out choices selectable in preview for diagnosis. Checkout remains blocked.
          const availableChoice = matching.some(v => v.available);
          btn.classList.toggle('is-unavailable', !availableChoice);
          btn.title = availableChoice ? '' : 'Sold out — unavailable for checkout';
          btn.classList.toggle('is-active', values[index] === val);
          btn.setAttribute('aria-pressed', String(values[index] === val));
          btn.addEventListener('click', () => {
            state[key].values[index] = val;
            if (!pickedVariant(key)) {
              const available = getVariants(record).find(v => v.available && v.options?.[index] === val);
              if (available) state[key].values = [...available.options];
            }
            showOptions(key); updateProductImage(key); refresh();
          });
          buttons.append(btn);
        });
        group.append(buttons); target.append(group);
      });
      const inventory = slot.querySelector('[data-inventory]');
      const selected = chosenVariant(key);
      inventory.textContent = !selected ? 'Select your options.' : selected.available ? '' : 'This combination is sold out.';
    }

    function updateProductImage(key) {
      if (key === 'jods') return;
      const slot = root.querySelector(`[data-slot="${key}"]`);
      const container = slot?.querySelector('[data-product-image]');
      const record = state[key]?.record;
      const variant = chosenVariant(key);
      if (!container || !record) return;
      const url = variant?.featured_image || record.product.featured_image;
      if (!url) return;
      let img = container.querySelector('img');
      if (!img) {
        img = document.createElement('img');
        img.loading = 'lazy';
        container.append(img);
      }
      if (img.getAttribute('src') !== url) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = url;
      }
      img.alt = variant?.title && variant.title !== 'Default Title'
        ? `${record.product.title} - ${variant.title}`
        : record.product.title;
    }

    function useProduct(key, record) {
      state[key] = { record, values: initialValues(record) };
      showOptions(key);
      updateProductImage(key);
      refresh();
    }

    for (const key of ['shirt','gloves','socks']) {
      const record = byKind(key)[0];
      if (record) useProduct(key, record);
    }

    const jods = byKind('jods');
    jods.forEach(r => {
      const parent = root.querySelector(`[data-swatches="${r.group}"]`);
      if (!parent) return; // Show configured colors, including sold-out ones during testing.
      const btn = make('button', 'sse__swatch');
      btn.type = 'button'; btn.dataset.productId = String(r.product.id);
      btn.setAttribute('aria-label', `Select ${r.color}${isAvailable(r) ? '' : ' (sold out)'}`);
      btn.classList.toggle('is-unavailable', !isAvailable(r));
      const circle = make('span', 'sse__swatch-circle');
      if (r.image) {
        const img = document.createElement('img');
        img.src = r.image; img.alt = ''; img.loading = 'lazy'; circle.append(img);
      } else circle.style.backgroundColor = r.hex;
      const name = make('span', 'sse__swatch-name', r.color);
      btn.append(circle, name);
      if (!isAvailable(r)) btn.append(make('span', 'sse__new', 'Sold out')); 
      if (r.isNew) btn.append(make('span', 'sse__new', 'NEW!'));
      btn.addEventListener('click', () => {
        useProduct('jods', r);
        root.querySelector('[data-color-name]').textContent = r.color;
        root.querySelectorAll('.sse__swatch').forEach(b => {
          const active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-pressed', String(active));
        });
        const display = root.querySelector('[data-selected-jods]');
        display.replaceChildren();
        if (r.product.featured_image) {
          const img = document.createElement('img');
          img.src = r.product.featured_image; img.alt = r.product.title;
          img.loading = 'lazy'; display.append(img);
        }
        const content = make('div', '', '');
        content.append(make('p', 'sse__product-name', r.product.title));
        const variant = chosenVariant('jods');
        content.append(make('p', 'sse__regular-price', variant ? `Regular price: ${money(variant.price)}${variant.available ? '' : ' — Sold out'}` : 'Select size')); 
        display.append(content);
        refresh();
      });
      parent.append(btn);
    });
    root.querySelectorAll('[data-swatch-group]').forEach(g => {
      g.hidden = !g.querySelector('.sse__swatch');
    });
    // Only preselect the first eligible Jods to make testing faster.
    (jods.find(isAvailable) && root.querySelector(`.sse__swatch[data-product-id="${jods.find(isAvailable).product.id}"]`) || root.querySelector('.sse__swatch'))?.click();

    function refresh() {
      const entries = ['shirt','jods','gloves','socks'].map(key => ({key, record: state[key]?.record, variant: pickedVariant(key)}));
      const jodPrice = chosenVariant('jods')?.price;
      const upcharge = PRICE_UPGRADES.get(jodPrice);
      const valid = entries.every(e => e.variant) && upcharge !== undefined;
      const summary = root.querySelector('[data-summary-items]');
      summary.replaceChildren();
      entries.forEach(entry => {
        const line = make('div', 'sse__summary-item');
        const short = {shirt:'Shirt', jods:'Jods', gloves:'Gloves', socks:'Socks'}[entry.key];
        line.append(make('strong', '', short), make('span', '', entry.variant ? `${entry.record.product.title} — ${entry.variant.title}` : chosenVariant(entry.key) ? `${entry.record.product.title} — ${chosenVariant(entry.key).title} (sold out)` : 'Not selected'));
        summary.append(line);
      });
      root.querySelector('[data-upcharge]').textContent = upcharge === undefined ? '—' : money(upcharge);
      root.querySelector('[data-bundle-total]').textContent = upcharge === undefined ? '—' : money(21500 + upcharge);
      if (!testCartEnabled) {
        addButton.disabled = true; addButton.textContent = 'Preview mode — cart disabled';
      } else {
        addButton.disabled = !valid;
        addButton.textContent = valid ? 'Add Bundle to Cart' : 'Select available items';
      }
      if (jodPrice != null && upcharge === undefined) setMessage('This Jods price tier is not configured for the bundle.');
      else setMessage('');
    }

    let isAdding = false;
    addButton.addEventListener('click', async () => {
      if (!testCartEnabled || addButton.disabled || isAdding) return;
      const keys = ['shirt','jods','gloves','socks'];
      const selected = keys.map(pickedVariant);
      if (selected.some(v => !v)) return;
      if (!PRICE_UPGRADES.has(selected[1].price)) return;

      // Bundler handles the per-Jods product discounts ($28 or $38).
      // Only add the four real products; no extra upgrade SKU is required.
      const items = selected.map(v => ({id: v.id, quantity: 1}));
      isAdding = true;
      addButton.disabled = true; addButton.textContent = 'Adding…'; setMessage('');
      try {
        const resp = await fetch(root.dataset.addUrl, {
          method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({items})
        });
        if (!resp.ok) {
          const error = await resp.json().catch(() => ({}));
          throw new Error(error.description || error.message || 'Could not add bundle to cart.');
        }
        // Shopify has accepted all four products. Never redirect to /cart.
        // The Rebuy Smart Cart does not render on Shopify's /cart page.
        if (window.Rebuy?.SmartCart?.show) {
          try {
            if (typeof window.Rebuy.Cart?.fetchCart === 'function') {
              await window.Rebuy.Cart.fetchCart();
            }
            window.Rebuy.SmartCart.show();
          } catch (rebuyError) {
            console.warn('[Saddle Seat Essentials] Rebuy Smart Cart error', rebuyError);
            setMessage('Bundle added, but Smart Cart could not open. Please use the cart icon.');
          }
        } else {
          console.warn('[Saddle Seat Essentials] Rebuy Smart Cart not available on this page. Check the Rebuy app embed and published Smart Cart.');
          setMessage('Bundle added. Smart Cart is not available; please use the cart icon.');
        }
      } catch (error) {
        setMessage(error.message || 'Could not add the bundle.');
      } finally {
        isAdding = false;
        refresh();
      }
    });
    refresh();
  }

  function boot() { document.querySelectorAll('[data-sse-root]').forEach(start); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
